import { getCookie } from 'src/assets/js/dom'
import store from 'src/store'

let uid = 0
if(store.state.userInfo){
    uid = JSON.parse(store.state.userInfo).id || 0
}
export const commonParams = {
    'uid': uid || 0,
}
export const STATUS_OK = 1
export const STATUS_ERR = 0

let apiUrl='',
    baseUrl='',
    domainUrl=''
let url = window.location.hostname
if(url === 'tiku.buzhi.com' || url === 'tiku.test.buzhi.com'){
    domainUrl = 'http://g.buzhi.com'
    apiUrl ='//tiku.g.buzhi.com'
    baseUrl = '//tiku.buzhi.com'
}else{
    domainUrl = 'http://beta.gk.buzhi.com'
    apiUrl ='//tiku.gk.buzhi.com'
    baseUrl = '//tiku.beta.buzhi.com'
}
export const loginRef = domainUrl + '/login?ref='
export const buyUrl = domainUrl + '/Pay/Cart/index/target_id/4/type/course'
export const mockSignUrl = domainUrl + '/Course/Mock/index'
export const studyUrl = domainUrl + '/course/vip?cid=2'
export {
    apiUrl,
    baseUrl,
    cookieName
}



// WEBPACK FOOTER //
// ./src/assets/api/config.js